// extracted by mini-css-extract-plugin
module.exports = {"contactStyles":"pages-contact-styles__contactStyles","background":"pages-contact-styles__background"};